// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__wblzX","alert":"SettungsInbox_alert__2c4qs"};